"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import { Text } from '../../../Text/Text.mjs';
import styles from './LegendItem.module.scss.mjs';
import { categoricalColors } from '../../../../lib/tokens/CategoricalColors.mjs';
import { getCategoricalColorValue } from '../../../../lib/tokens/getCategoricalColorValue.mjs';

const LegendItem = (props) => {
  const { children, color } = props;
  return /* @__PURE__ */ jsxs("li", { className: styles.legendItem, children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: styles.colorSquare,
        style: {
          backgroundColor: categoricalColors.includes(
            color
          ) ? getCategoricalColorValue(color) : color
        }
      }
    ),
    /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx("small", { children }) })
  ] });
};

export { LegendItem, LegendItem as default };
//# sourceMappingURL=LegendItem.mjs.map
